import { render, staticRenderFns } from "./ActiveFlows.vue?vue&type=template&id=5cd88572&scoped=true&"
import script from "./ActiveFlows.vue?vue&type=script&lang=js&"
export * from "./ActiveFlows.vue?vue&type=script&lang=js&"
import style0 from "./ActiveFlows.vue?vue&type=style&index=0&id=5cd88572&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd88572",
  null
  
)

export default component.exports